import cx from "classnames"
import Skeleton from "src/shared/components/layout/skeleton/Skeleton"
import Icon from "src/shared/icons"
import CarouselGroup from "../carousel-group"
import { Aviso } from "./Aviso"
import { AvisoFijo } from "./AvisoFijo"
import DateSection from "../date"
import Image from "../Image"
import Turno from "../turno/Turno"
import "./NoticesSection.css"

interface NoticesSectionProps {
    logo?: string
    loading: boolean
    imgPromoH?: string[]
    imgPromoV?: string[]
    showListaEsperaTitle?: boolean
    onListaEsperaTitleClick?: () => void
    showExternalLinkIcon?: boolean
    folioTurn?: string
    avisos: string[]
}

export default function NoticesSection({
    logo,
    loading,
    imgPromoH,
    imgPromoV,
    showListaEsperaTitle = false,
    onListaEsperaTitleClick,
    showExternalLinkIcon = false,
    folioTurn,
    avisos = []
}: NoticesSectionProps) {
    
    const ListaEsperaTitle = () => (
        <p 
            className={`disp__card-list-title ${showExternalLinkIcon ? 'disp__card-list-title--clickable' : ''}`}
            onClick={onListaEsperaTitleClick}
        >
            Lista de espera para habitaciones
            {showExternalLinkIcon && (
                <Icon 
                    name="ExternalLinkFill" 
                    width={40} 
                    height={40} 
                    color="var(--white)" 
                    style={{ marginLeft: "20px" }} 
                />
            )}
        </p>
    )

    // Esta rama aún no tiene avisos configurables en el panel: sin avisos se muestran los mensajes fijos de siempre.
    const avisosFijos = [
        <AvisoFijo id="promo-bebida" key="promo-bebida">
            <p className="disp__message">
                Si llevas más de <strong>30 min</strong> esperando,
                <br />
                <strong>¡Te invitamos una bebida!</strong>
            </p>
            <p className="disp__message-metodo">
                Métodos de pago: efectivo y tarjetas de crédito
            </p>
        </AvisoFijo>,
        <AvisoFijo id="promo-ticket" key="promo-ticket">
            <p className="disp__message">
                Si no le dan <strong>ticket</strong> o <strong>le solicitan propina</strong> para entregar habitación,
                su habitación será <strong>gratis.</strong>
            </p>
        </AvisoFijo>,
    ]

    const buildAvisos = avisos.length > 0 ? avisos.map((aviso, index)=>(
        <Aviso value={aviso} key={`aviso-base-${index}`} />
    )) : avisosFijos

    const messageSlides = folioTurn ? [
        <div className="disp__message-slide" key={`turno-${folioTurn}`}>
            <Turno folioTurno={folioTurn} size="normal"/>
        </div>,
        ...buildAvisos
    ] : buildAvisos

    const renderTurnSection = () => {
        if (loading) {
            return <Skeleton.Item className="disp__skeleton" />
        }

        if (messageSlides.length === 0) {
            return (
                <div className="disp__message-empty">
                    <Icon name={"image"} height={60} width={60} color={"var(--drawer)"} />
                </div>
            )
        }

        return (
            <CarouselGroup className="disp__message-carousel">
                {messageSlides}
            </CarouselGroup>
        )
    }

    return (
        <div className="disp__notices">
            <div
                className={cx({
                    "disp__notices-column": true,
                    "disp__notices-column__logo": !!logo,
                })}
            >
                <div className="disp__notices-section-date">
                    <div className="disp__logo-lista-espera">
                        {logo && <img className="disp__logo" src={logo} alt="Logo" />}
                        {showListaEsperaTitle && <ListaEsperaTitle />}
                    </div>
                    <div className="disp__date-wrapper">
                        <DateSection />
                    </div>
                </div>

                <div className="disp__notices-section-info">
                    <div className="disp__notices-section-turn">
                        {renderTurnSection()}
                    </div>
                    <div className="disp__notices-section-promo">
                        {loading ? (
                            <Skeleton.Item className="disp__skeleton" />
                        ) : (
                            <> 
                                {Number(imgPromoH?.length) > 0 ? (
                                    <CarouselGroup className="carousel__promo carousel__promo-img--horizontal">
                                        {imgPromoH?.map((url, i) => (
                                            <Image key={`h-${i}`} className={`promo-img ${imgPromoH?.length === 1 ? "promo-img-horizontal" : ""}`} src={url} />
                                        ))}
                                    </CarouselGroup>
                                ) : (
                                    <div className="carousel__promo carousel__promo-img--horizontal carousel__promo-img__empty">
                                        <Icon name={"image"} height={60} width={60} color={"var(--drawer)"} />
                                    </div>
                                )}
                                {Number(imgPromoV?.length) > 0  ? (
                                    <CarouselGroup className="carousel__promo carousel__promo-img--vertical">
                                        {imgPromoV?.map((url, i) => (
                                            <Image key={`v-${i}`} className={`promo-img ${imgPromoV?.length === 1 ? "promo-img-vertical" : ""}`} src={url} />
                                        ))}
                                    </CarouselGroup>
                                ) : (
                                    <div className="carousel__promo carousel__promo-img--vertical carousel__promo-img__empty">
                                        <Icon name={"image"} height={40} width={40} color={"var(--drawer)"} />
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}